import React, { useEffect, useState } from "react";
import "./CustomList.style.scss";
import { Input, Checkbox, Tooltip } from "antd";
import clsx from "clsx";
import { P_Props, RawListProps, CheckboxListProps } from "./CustomList.type";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { SearchOutlined } from "@ant-design/icons";
import { OtherUtil } from "utils/other";

const CustomListPresenter = <T extends {}>(props: P_Props<T>) => {
  const { t } = useTranslation();
  const [cloneList, setCloneList] = useState<any>([]);

  useEffect(() => {
    // if (!_.isEmpty(props.list)) {
    setCloneList(props.list);
    // }
  }, [props.list]);

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    let newData: any[] = [];

    if (value) {
      const valueText = OtherUtil.nonAccentVietnamese(value);
      props.list.forEach((item) => {
        // search by fields
        if (props.searchByKey?.length) {
          const searchArr: string[] = props.searchByKey
            .map((s) => OtherUtil.nonAccentVietnamese((item[s] || "") as any))
            .filter(Boolean);
          if (searchArr.findIndex((i) => i.includes(valueText)) > -1) newData.push(item);
        } else {
          // search by display text
          const displayText = OtherUtil.nonAccentVietnamese(props.renderLabel(item));
          if (displayText.includes(valueText)) newData.push(item);
        }
      });
      setCloneList(newData);
    } else {
      setCloneList(props.list);
    }
  };

  return (
    <div className="custom-list">
      {props.search && Boolean(props.list.length) && (
        <div className="custom-list__search">
          <Input
            onChange={onSearch}
            prefix={<SearchOutlined color="#444C53" />}
            placeholder={t("SEARCH_BY_NAME")}
            className="item input input__text-md"
          />
        </div>
      )}

      {props.renderWith === "checkbox" && !!cloneList.length && <CheckBoxList {...props} cloneList={cloneList} />}

      {props.renderWith === "raw" && !!cloneList.length && <RawList {...props} />}
    </div>
  );
};

const RawList: React.FC<RawListProps> = (props) => {
  const { t } = useTranslation();
  const titleAll = props.titleSelectAll || t("ALL_LOCATIONS");
  return (
    <div className="custom-list__raw-list">
      {props.rawAll && props.list.length > 1 && (
        <Tooltip title={props.titleSelectAll}>
          <div
            onClick={(e) =>
              OtherUtil.loadCallback(
                props.onChange,
                props.list.map((d) => d.id)
              )
            }
            className={clsx({
              "custom-list__raw-list__item": true,
              active: _.isEqual(
                props.value,
                props.list.map((d) => d.id)
              ),
            })}
          >
            {/* {props.showImage && (
              <CustomAvatar size={32} placeholder={"A"} className="custom-list__raw-list__item__ava" />
            )} */}
            {titleAll}
          </div>
        </Tooltip>
      )}

      {props.list.map((d) => {
        const itemClass = clsx({
          "custom-list__raw-list__item": true,
          active: _.isEqual(props.value, props.rawAll ? [d.id] : d.id),
        });
        return (
          <Tooltip key={d.id} title={props.renderLabel(d)}>
            <div
              onClick={(e) => OtherUtil.loadCallback(props.onChange, props.rawAll ? [d.id] : d.id)}
              className={itemClass}
            >
              {/* {props.showImage && (
                <CustomAvatar
                  size={32}
                  placeholder={props.renderLabel(d)}
                  src={d.photo}
                  className="custom-list__raw-list__item__ava"
                />
              )} */}
              {props.renderLabel(d)}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
};

const CheckBoxList: React.FC<CheckboxListProps> = (props) => {
  const { t } = useTranslation();
  const checkBoxAllClass = clsx({
    "custom-list__checkbox-list__all": true,
    divideLine: props.divideLine,
  });

  const indeterminate = Boolean(props.value?.length) && props.value?.length < props.list?.length;
  const isSelectedAll = props.cloneList.length === props.value?.length;

  return (
    <div className="custom-list__checkbox-list">
      <Checkbox
        className={checkBoxAllClass}
        indeterminate={indeterminate}
        onChange={() => {
          if (!isSelectedAll) {
            OtherUtil.loadCallback(
              props.onChange,
              props.cloneList.map((d) => d.id)
            );
          } else {
            OtherUtil.loadCallback(props.onChange, []);
          }
        }}
        checked={isSelectedAll}
      >
        {props.titleSelectAll || t("SELECT_ALL")} ({props.cloneList.length})
      </Checkbox>

      <Checkbox.Group className="custom-list__checkbox-list__item" value={props.value} onChange={props.onChange}>
        {props.cloneList.map((d, idx) => {
          return (
            <Tooltip key={d.id} title={props.renderLabel(d)}>
              <Checkbox key={d.id} value={d.id}>
                {/* {props.showImage && (
                  <CustomAvatar
                    size={32}
                    placeholder={props.renderLabel(d)}
                    src={d.avatarPath}
                    className="custom-list__raw-list__item__ava"
                  />
                )} */}
                {props.renderLabel(d)}
              </Checkbox>
            </Tooltip>
          );
        })}
      </Checkbox.Group>
    </div>
  );
};

export default CustomListPresenter;
